import React from 'react'

export default function TextWIcon(props) {
  const {text, icon, iconPlacement="after"} = props
  return (
    <>
      {iconPlacement === "before" && <span className="mr-1 inline-block">{icon}</span>} 
      {text} {iconPlacement === "after" && <span className="ml-1 inline-block">{icon}</span>}
    </>
  )
}
